export default __webpack_public_path__ + "img/dlLgnDZc.e2e42ab0.svg";